
/**
 * Constants for data columns.
 * @hidden
 */
export class DataConstants {

    /**
     * Generated row index of datarow.
     */
    public static readonly ROW_INDEX_COLUMN_NAME = "__RowIndex";

    /**
     * Unique guid for datarow.
     */
    public static readonly ROW_GUID_COLUMN_NAME = "__RowGuid";

    /**
     * Unique guid for the parent datarow.
     */
    public static readonly PARENT_ROW_GUID_COLUMN_NAME = "__ParentRowGuid";

    /**
     * Row guid of the datarow which was used as parameter.
     */
    public static readonly FROM_ROW_GUID_COLUMN_NAME = "__FromRowGuid";

    /**
     * Row guid of the parent datarow which was used as parameter.
     */
    public static readonly FROM_PARENT_ROW_GUID_COLUMN_NAME = "__FromParentRowGuid";

    /**
     * Generated hash code for all row values.
     */
    public static readonly ROW_HASH_COLUMN_NAME = "__RowHash";
}
